'use client';
import React, { Component } from 'react';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Complex from '../reusable-components/layouts-components__linkbuilder/complex';
import Process from '../reusable-components/layouts-components__linkbuilder/tasks';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import FullBlueContent from '../reusable-components/layouts-components__linkbuilder/full-blue-content';
import HowWork from '../reusable-components/layouts-components__linkbuilder/how-work';
import Algoritm from '../reusable-components/layouts-components__linkbuilder/algoritm';
import System from '../reusable-components/layouts-components__linkbuilder/system';

import './style.sass';
import '../reusable-components/style.sass';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonNav from '../common-components/common-nav';

const linkbuilderMainTitle = {
    titleMainText: `Linkbuilder.Ai: как ИИ меняет правила игры на рынке линкбилдинга`,
    titleAnimation: '/images/svg/linkbuilder/linkbuilder.png',
    subtitleContainer: [
        {
            modeText: 'Отрасль',
            colorMode: '#00B9FF',
            nameText: 'Технологии',
        },
        {
            modeText: 'Технологии',
            colorMode: '#00B9FF',
            nameText: 'Big Data, AI',
        },
    ],
};

class Linkbuilder extends Component {
    render() {
        const casePathname = '/cases/products/linkbuilder';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="linkbuilder">
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Продукты"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <div className="linkbuilder__title-wrap">
                    <MainTitle MainTitle={linkbuilderMainTitle} />
                </div>

                <Complex />

                <FullBlueContent />

                <Process />

                <HowWork />

                <Algoritm />

                <System />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default Linkbuilder;
